"use client";

import NextLink from "components/parts/NextLink";
import { Button } from "app/_components/components/Button";
import { cn } from "app/_components/components/utils";

export function CustomCardButton({
  children,
  className,
  href,
  id,
  size = "md"
}: {
  children: React.ReactNode;
  className?: string;
  href: string;
  id: string;
  size?: "sm" | "md" | "lg" | "icon";
}) {
  return (
    <Button
      asChild
      className={cn("relative! z-[2]!", className)}
      size={size}
      variant="primary"
    >
      <NextLink className="!text-white" href={href} id={`${id}-button`}>
        {children}
      </NextLink>
    </Button>
  );
}
